export enum TermsAndConditionRoutes {
    ACCEPT_TERMS = "/accept-terms",
}
